import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  ContentSection,
  FlexColumn,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  Text,
  FloatingButton,
  FlexRowFluid,
  SwipeTabs,
  SwipeTab,
  StyledToggleButtonGroup,
} from "../../styles/Global";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import * as Global from "../../styles/Global";
import {
  FaUserCircle,
  FaQrcode,
  FaPeopleArrows,
  FaBalanceScale,
} from "react-icons/fa";
import { AiFillSetting, AiOutlineLineChart } from "react-icons/ai";
import { BiEdit } from "react-icons/bi";
import { MdCompareArrows } from "react-icons/md";
import StatBlock from "./StatBlock";
import "../../App.scss";
import "animate.css";
import {
  useGetProfileSingleMutation,
  useMatchHistorySingleMutation,
  useRemoveFromClubMutation,
  usePprSummaryMutation,
} from "../../services/playerApi";
import { useNavigate } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  setPlayer,
  clearPlayer,
  setPlayerNull,
} from "../../features/player/playerSlice";
import { setModal } from "../../features/modals/modalSlice";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import { playerHistoryColDefs } from "../charts/columnDefs/columnDefs";
import { playerHistoryGroupColDefs } from "../charts/columnDefs/columnDefs";
import loadable from "@loadable/component";
import { LicenseManager } from "@ag-grid-enterprise/core";
import UpgradeBlurComponent from "../../components/UpgradeBlurComponent";
import { MdPersonRemove } from "react-icons/md";
import { toast } from "react-toastify";
import Confirmation from "./modals/Confirmation";
import SlideUp from "../../components/modals/SlideUp";
import { setRefreshMainProfile } from "../../features/refreshScreen/refreshScreenSlice";
import ScoremagicStats from "./components/scoremagicStats";
import SkeletonLoader from "../../components/SkeletonLoader";
import { allAccessUsers } from "../organizer/forms/formSelectArrays";
import MainProfileModals from "./modals/MainProfileModals";
import { LaunchDash, OpenExternalURL } from "../../functions/helperFunctions";
import ScoremagicStatsHorseshoes from "./components/scoremagicStatsHorseshoes";
import stateList from "../../services/stateList.json";
import provinceList from "../../services/provinceList.json";
import { GiLaurelsTrophy } from "react-icons/gi";
import moment from "moment";
import ScoremagicStatsWrapper from "./components/scoremagicStatsWrapper";
import { ToggleButton } from "@mui/material";
LicenseManager.setLicenseKey(
  "CompanyName=Scoreholio Inc,LicensedApplication=Scoreholio,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-036853,SupportServicesEnd=6_March_2026_[v2]_MTc3Mjc1NTIwMDAwMA==c1e9b989582d1581fc31da5b0be0f677"
);

const UnverifiedProfile = loadable(() => import("./UnverifiedProfile"));
const SwipeCharts = loadable(() => import("../charts/SwipeCharts"));
const GridTable = loadable(() => import("../../components/GridTable"));
const GridTableClient = loadable(() =>
  import("../../components/GridTableClient")
);

const mapDispatch = {
  setPlayer,
  setModal,
  clearPlayer,
  setPlayerNull,
  setRefreshMainProfile,
};

const MainProfile = ({
  setPlayer,
  setModal,
  isDifferentUser,
  externalData,
  clearPlayer,
  setRefreshMainProfile,
  setPlayerNull,
}) => {
  const playerModals = useSelector((state) => state.modal.playerModals);
  const playerModals2 = useSelector((state) => state.modal.playerModals2);
  const playerModals4 = useSelector((state) => state.modal.playerModals4);
  const globalModals = useSelector((state) => state.modal.globalModals);
  const globalModals2 = useSelector((state) => state.modal.globalModals2);
  const EOYRecap = useSelector((state) => state.modal.EOYRecap);
  const orgSeasonModals = useSelector((state) => state.modal.orgSeasonModals);
  const darkMode = useSelector((state) => state.global.darkMode);
  const navigate = useNavigate();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const player = useSelector((state) => state.player);
  const localStoragePlayer =
    JSON.parse(localStorage.getItem("player")) || player;
  const refreshProfile = useSelector(
    (state) => state.refresh.refreshMainProfile
  );
  const requestCorrection = useSelector(
    (state) => state.modal.requestCorrection
  );
  const tabsRef = useRef();
  const [pprSummary30, setPprSummary30] = useState(null);
  const [pprSummary120, setPprSummary120] = useState(null);
  const [pprSummaryAll, setPprSummaryAll] = useState(null);
  const [viewType, setViewType] = useState(2);
  const [displayModal, setDisplayModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [modalType, setModalType] = useState(0);
  const [formatType, setFormatType] = useState("all");
  const [showAdvancedStats, setShowAdvancedStats] = useState(false);
  const [showUnverifiedOrGuestProfile, setShowUnverifiedOrGuestProfile] =
    useState(true);
  const [showSendVerificationEmail, setShowSendVerificationEmail] =
    useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(
    viewType > 0 ? true : false
  );
  const params = new URLSearchParams(window.location.search);
  // console.log("MainProfile token: ", params.get("token"));
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const [userid, setUserid] = useState(
    //params.get("user") || localStoragePlayer.userID
    params.has("user") ? params.get("user") : localStoragePlayer.userID
  );
  const [accountid, setAccountid] = useState(
    params.get("account") || localStoragePlayer.accountID
  );
  console.log("params.get(account): ", params.get("account"));
  const [token, setToken] = useState(
    params.get("token") || localStoragePlayer.token
  );
  const [isadmin, setIsadmin] = useState(
    params.get("isadmin") || localStoragePlayer.isAdmin
  );
  const [pin, setPin] = useState(params.get("pin") || localStoragePlayer.pin);
  const [build, setBuild] = useState(
    params.get("build") || localStoragePlayer.build
  );
  const [platform, setPlatform] = useState(params.get("platform"));
  function SetPaidStatus(param, storage) {
    let isPaid = false;
    const status = params.get(param);
    if (!status) {
      isPaid = storage;
    } else if (status === "Yes") {
      isPaid = true;
    }
    return isPaid;
  }
  const [paidOrganizer, setPaidOrganizer] = useState(
    SetPaidStatus("paidOrganizer", localStoragePlayer.paidOrganizer)
    // (params.get("paidOrganizer") && params.get("paidOrganizer") == "Yes") ||
    //   localStoragePlayer.paidOrganizer
    //   ? true
    //   : false
  );
  const [paidPlayer, setPaidPlayer] = useState(
    SetPaidStatus("paidPlayer", localStoragePlayer.paidPlayer)
    // (params.get("paidPlayer") && params.get("paidPlayer") == "Yes") ||
    // localStoragePlayer.paidPlayer
    // ? true
    // : false
  );
  const [getProfileSingle, { data, error, isLoading }] =
    useGetProfileSingleMutation();
  const [
    getPprSummary30,
    { data: pprData30, error: pprError30, isLoading: pprIsLoading30 },
  ] = usePprSummaryMutation();
  const [
    getPprSummary120,
    { data: pprData120, error: pprError120, isLoading: pprIsLoading120 },
  ] = usePprSummaryMutation();
  const [
    getPprSummaryAll,
    { data: pprDataAll, error: pprErrorAll, isLoading: pprIsLoadingAll },
  ] = usePprSummaryMutation();

  window.logoutExternal = async function () {
    try {
      console.log("logoutExternal");
      localStorage.removeItem("player");
    } catch (error) {
      console.log(error);
      console.log("logoutExternal ERROR: ", error);
    }
  };

  console.log("pprData30: ", pprData30);
  console.log("pprData120: ", pprData120);
  console.log("pprErrorAll: ", pprErrorAll);
  console.log("pprDataAll: ", pprDataAll);
  console.log("externalData: ", externalData);
  console.log("MainProfile player: ", player);
  // console.log("params.get('paidOrganizer'): ", params.get("paidOrganizer"));
  async function GetDetailData(params, tag) {
    console.log("GetDetailData params: ", params);
    const bodyData = {
      userid: params.data.userid,
      gameid: params.data.gameid,
    };
    console.log(bodyData);
    await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/apiv2/player/v2/match-history-group-detail`,
      {
        method: "POST",
        body: JSON.stringify(bodyData),
        headers: { "Content-Type": "application/json; charset=utf-8" },
      }
    )
      .then((httpResponse) => httpResponse.json())
      .then((response) => {
        console.log("GetDetailData response: ", response);
        params.successCallback(response.rows);
      })
      .catch((error) => {
        console.error("GetDetailData error: ", error);
        //   params.failCallback();
      });
  }
  const detailCellRendererParams = useMemo(() => {
    function onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    }

    return {
      detailGridOptions: {
        overlayLoadingTemplate:
          "<span><img height='50' src='https://app.scoreholio.com/img/loading400.gif'/></span>",
        rowSelection: "single",
        suppressRowClickSelection: true,
        suppressMovableColumns: true,
        enableRangeSelection: true,
        animateRows: true,
        pagination: true,
        embedFullWidthRows: true,
        suppressSizeToFit: true,
        // paginationAutoPageSize: true,
        columnDefs: playerHistoryColDefs,
        defaultColDef: {
          sortable: true,
        },
        onRowClicked: (params) => {
          const selectedRow = params.data;
          console.log("selectedRow: ", selectedRow);
          ShowModalType(2, selectedRow);
          setModalData(selectedRow);
        },
      },
      getDetailRowData: (params) => {
        console.log("getDetailRowData params: ", params);
        GetDetailData(params);
      },
      onGridReady: (params) => {
        params.api.sizeColumnsToFit();
      },
      onFirstDataRendered: onFirstDataRendered,
    };
  }, []);
  function getPprSummary(type) {
    // console.log("getPprSummary type: ", type);
    const body = {
      sport: sport,
      userid: isDifferentUser ? externalData._source.userID : userid,
      timezone: tz,
      range: type === 0 ? "30" : type === 1 ? "120" : "all",
      matchtype: formatType,
    };
    if (type === 0) {
      getPprSummary30(body);
    } else if (type === 1) {
      getPprSummary120(body);
    } else if (type === 2) {
      getPprSummaryAll(body);
    }
  }

  //console.log("getprofile error: ", error);
  const rowClassRulesProfileMatch = useMemo(() => {
    return {
      strikethrough: function (params) {
        if (params.data) {
          return params.data.status === "Deleted";
        } else {
          return false;
        }
      },
    };
  }, []);
  const [
    getMatchHistory,
    {
      data: matchHistoryData,
      error: matchHistoryError,
      isLoading: matchHistoryLoading,
    },
  ] = useMatchHistorySingleMutation();
  // const [
  //   removePlayerFromClub,
  //   {
  //     data: removePlayerFromClubData,
  //     error: removePlayerFromClubError,
  //     isLoading: removePlayerFromClubLoading,
  //   },
  // ] = useRemoveFromClubMutation();

  // console.log("removePlayerFromClubData: ", removePlayerFromClubData);
  // console.log("showUnverifiedOrGuestProfile: ", showUnverifiedOrGuestProfile);

  // useEffect(() => {
  //   if (removePlayerFromClubData && removePlayerFromClubData.statusCode === 0) {
  //     setTimeout(() => {
  //       setRefreshMainProfile();
  //     }, [2000]);
  //     toast.success("Player removed from club!");
  //   }
  // }, [removePlayerFromClubData]);
  useEffect(() => {
    if (
      data &&
      !showUnverifiedOrGuestProfile &&
      !data.hasOwnProperty("avatarLink")
    ) {
      // console.log("REFRESHING MAIN PROFILE");
      setRefreshMainProfile();
    }
  }, [data]);
  useEffect(() => {
    if (!isDifferentUser) ShowUnverifiedOrGuest();
  }, [pin, userid, isadmin]);
  useEffect(() => {
    setViewType(
      player.paidOrganizer || player.paidPlayer || player.isAdmin ? 2 : 1
    );
  }, [paidPlayer, player]);
  useEffect(() => {
    // console.log(
    //   "MainProfile UseEffect localStoragePlayer: ",
    //   localStoragePlayer
    // );
    if (!player.userID && !params.has("user") && localStoragePlayer.userID) {
      // console.log(
      //   "MAIN PROFILE !player.userID && localStoragePlayer.userID: ",
      //   localStoragePlayer
      // );
      setPlayer(localStoragePlayer);
    } else if (player && !isDifferentUser) {
      console.log("useEffect to set playerSlice action normally");
      if (player.userID) {
        setUserid(player.userID);
      } else if (userid) {
        setPlayer({ userid });
      }
      if (player.accountID) {
        setAccountid(player.accountID);
      } else if (accountid) {
        setPlayer({ accountid });
      }
      if (player.token) {
        setToken(player.token);
      } else if (token) {
        setPlayer({ token });
      }
      if (player.pin) {
        setPin(player.pin);
      } else if (pin) {
        setPlayer({ pin });
      }
      if (player.paidOrganizer) {
        setPaidOrganizer(player.paidOrganizer);
      } else if (paidOrganizer) {
        setPlayer({ paidOrganizer });
      }
      if (player.paidPlayer) {
        setPaidPlayer(player.paidPlayer);
      } else if (paidPlayer) {
        setPlayer({ paidPlayer });
      }
      if (player.isAdmin) {
        setIsadmin(player.isAdmin && "true");
      } else if (isadmin) {
        setPlayer({ isAdmin: isadmin && isadmin === "true" });
      }
      if (sport) {
        setPlayer({ sport: sport });
      }
      if (build) {
        setPlayer({ build: parseInt(build) });
      }
      if (platform) {
        setPlayer({ platform: platform });
      }
    }
    ShowUnverifiedOrGuest();
  }, [player]);

  // console.log("player build #: ", player.build);

  useEffect(() => {
    // console.log("isDiffUser: ", isDifferentUser);
    // console.log("player: ", player);
    // console.log("userid: ", userid);
    // console.log("pin: ", pin);
    // console.log("player.pin: ", player.pin);
    const body = {
      sport: sport,
      isadmin: isDifferentUser ? (player.isAdmin ? "true" : "false") : isadmin,
      authid: isDifferentUser ? player.userID : userid,
      userid: isDifferentUser ? externalData._source.userID : userid,
      pin: isDifferentUser
        ? player.pin
        : pin
        ? pin
        : !pin && userid && player.pin
        ? player.pin
        : player.pin
        ? player.pin
        : "verify",
    };
    console.log("getProfileSingle: ", body);

    if (!isDifferentUser) {
      getProfileSingle(body);
    } else if (isDifferentUser && externalData) {
      getProfileSingle(body);
    }
  }, [refreshProfile, showUnverifiedOrGuestProfile, externalData]);
  // useEffect(() => {
  //   if (pprData120 && pprData120.statusCode === 0) {
  //     setPprSummary120(pprData120);
  //   }
  // }, [pprData120]);
  useEffect(() => {
    if (pprData30 && pprData30.statusCode === 0) {
      console.log("pprData30: ", pprData30);
      setPprSummary30(pprData30);
    }
  }, [pprData30]);
  useEffect(() => {
    if (pprData120 && pprData120.statusCode === 0) {
      console.log("pprData120: ", pprData120);
      setPprSummary120(pprData120);
    }
  }, [pprData120]);
  useEffect(() => {
    if (pprDataAll && pprDataAll.statusCode === 0) {
      console.log("pprDataAll: ", pprDataAll);
      setPprSummaryAll(pprDataAll);
    }
  }, [pprDataAll]);
  useEffect(() => {
    if (data && !isDifferentUser && data.statusCode === 0) {
      console.log("mainProfile data: ", data);
      setPlayer({ profileData: data });
      setIsEmailVerified(true);
    }
    if (data && data.statusCode && data.statusCode > 0) {
      console.log("SETTING ALL PLAYER TO NULL!");
      setUserid(null);
      setPin(null);
      setUserid(null);
      setAccountid(null);
      setToken(null);
      setPaidPlayer(null);
      setIsadmin(null);
      setPlayerNull({
        displayName: "",
        pin: null,
        userID: null,
        email: null,
        //Leave paid organizer in state to avoid issues on next login without URL update
        // paidOrganizer: false,
        paidPlayer: false,
        isAdmin: false,
        sport: null,
        token: null,
        accountID: null,
        profileData: {},
      });
      setIsEmailVerified(false);
      setShowSendVerificationEmail(true);
      setShowUnverifiedOrGuestProfile(true);
      //Need to leave the token in the params so we know the device for the user
      navigate(`../${sport}/player/profile?token=${params.get("token")}`, {
        replace: true,
      });
      localStorage.removeItem("player");
    }
  }, [data]);
  console.log("mainProfile data: ", data);
  // console.log("player: ", player);
  // console.log("player.profileData: ", player.profileData);
  //console.log("viewType: ", viewType);
  console.log("isDifferentUser: ", isDifferentUser);
  // console.log("externalData: ", externalData);
  // console.log("error: ", error);
  // console.log("MainProfile sport: ", sport);
  // console.log("mainprofile token: ", token);
  // console.log("mainprofile accountid: ", accountid);
  // console.log("mainprofile userid: ", userid);
  // console.log("isadmin: ", isadmin);
  // console.log("paidPlayer: ", paidPlayer);
  // console.log("paidOrganizer: ", paidOrganizer);
  // console.log("pin: ", pin);
  // console.log("externalData: ", externalData);

  function ShowUnverifiedOrGuest() {
    let showUnverifiedOrGuest = true;
    let admin =
      (isadmin && isadmin === "true") || (isadmin && isadmin) || player.isAdmin;
    // console.log("showunverifiedorguest isadmin: ", isadmin);
    // console.log("showunverifiedorguest isadmin: ", admin);
    if (!admin && userid && userid !== "") showUnverifiedOrGuest = false;
    if (
      (!admin && pin && pin !== "" && !showUnverifiedOrGuest) ||
      admin ||
      isDifferentUser
    ) {
      showUnverifiedOrGuest = false;
    } else {
      showUnverifiedOrGuest = true;
    }
    if (showUnverifiedOrGuest && !player.isUnverified) {
      setPlayerNull({ ...player, isUnverified: true });
    } else if (!showUnverifiedOrGuest && player.isUnverified) {
      setPlayerNull({ ...player, isUnverified: false });
    }
    setShowUnverifiedOrGuestProfile(showUnverifiedOrGuest);
  }
  function ShowModalType(type, selectedRow) {
    console.log("showModalType: ", type);
    console.log("showModalType selectedRow: ", selectedRow);
    // setModalType(type);
    // setDisplayModal(true);
    setModal({
      playerModals4: {
        showModal: true,
        modalType: type,
        data:
          type === 5
            ? {
                type: "removeFromClub",
                accountid: player.accountID,
                sport: sport,
                userid: externalData._source.userID,
                ...data,
              }
            : selectedRow
            ? selectedRow
            : data,
      },
    });
  }
  // function RemovePlayerFromClub() {
  //   console.log("removing player from club...");
  //   removePlayerFromClub({
  //     accountid: player.accountID,
  //     sport: sport,
  //     userid: externalData._source.userID,
  //   });
  // }

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }
  const [value, setValue] = useState(1);
  const [playHistoryValue, setPlayHistoryValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    getPprSummary(newValue);
  };
  const handlePlayHistoryValueChange = (event, newValue) => {
    setPlayHistoryValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
    getPprSummary(index);
  };
  const handlePlayHistoryChangeIndex = (index) => {
    setPlayHistoryValue(index);
  };

  // console.log("isLoading: ", isLoading);
  console.log("mainProfile data 2: ", data);
  // console.log("showUnverifiedOrGuestProfile: ", showUnverifiedOrGuestProfile);

  useEffect(() => {
    if (!isDifferentUser) {
      getPprSummary(value);
    } else if (isDifferentUser && externalData) {
      getPprSummary(value);
    }
  }, [formatType, externalData]);

  function LaunchCompare() {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/v2/${sport}/scouting-report?comparison=1&user1=${
      player.userID
    }&user2=${externalData._source.userID}&type=selfcheckin&cache=${Math.random(
      123456789
    )}`;
    LaunchDash(platform, player, url);
  }

  useEffect(() => {
    setTimeout(() => {
      //This is a weird hacky fix for the scoremagic stats tab indicator not lining up properly on first load
      window.dispatchEvent(new CustomEvent("resize"));
    }, 1000);
  }, []);

  const formatTypeButtons = [
    <ToggleButton value="all" key="all">
      <Text size=".7em">Overall</Text>
    </ToggleButton>,
    <ToggleButton value="roundrobin" key="roundrobin">
      <Text size=".7em">Round Robin</Text>
    </ToggleButton>,
    <ToggleButton value="bracket" key="bracket">
      <Text size=".7em">Bracket</Text>
    </ToggleButton>,
  ];

  const handleFormatTypeChange = (event, newFormatType) => {
    if (newFormatType !== null) {
      setFormatType(newFormatType);
    }
  };

  const formatTypeControl = {
    value: formatType,
    onChange: handleFormatTypeChange,
    exclusive: true,
  };

  return isLoading || !data ? null : !isLoading &&
    data &&
    showUnverifiedOrGuestProfile ? (
    <UnverifiedProfile
      showUnverifiedOrGuest={showUnverifiedOrGuestProfile}
      userid={userid}
      setUserid={setUserid}
      pin={pin}
      setPin={setPin}
      data={data}
      showSendVerificationEmail={showSendVerificationEmail}
      setShowSendVerificationEmail={setShowSendVerificationEmail}
      resetEmailVerified={!isEmailVerified}
    />
  ) : data && data.statusCode && data.statusCode > 0 ? (
    <>
      <Text style={{ textAlign: "center" }}>{data.statusMessage}</Text>
    </>
  ) : !isLoading &&
    data &&
    data.statusCode === 0 &&
    !showUnverifiedOrGuestProfile &&
    data.hasOwnProperty("avatarLink") ? (
    <div
      className={isDifferentUser && "globalBackground"}
      style={{
        width: "100%",
        maxWidth: 600,
        margin: "0 auto",
      }}
    >
      {/* <MainProfileModals isDifferentUser={isDifferentUser} /> */}
      {!isDifferentUser && (
        <>
          {playerModals4.showModal && (
            <SlideUp
              displayModal={playerModals4.showModal}
              setDisplayModal={() =>
                setModal({
                  playerModals4: { showModal: false, modalType: 29, data: {} },
                })
              }
              modalType={playerModals4.modalType}
              CloseModalAction={() =>
                setModal({
                  playerModals4: { showModal: false, modalType: 29, data: {} },
                })
              }
              overlayZIndex={500}
              data={{ ...playerModals4.data, isDifferentUser }}
              modalData={{ ...modalData, isDifferentUser }}
              isEmailVerified={isEmailVerified}
              requestCorrection={requestCorrection}
            />
          )}
          {playerModals.showModal && (
            <SlideUp
              className={
                [26, 28, 29].includes(playerModals.modalType) &&
                "globalBackground"
              }
              displayModal={playerModals.showModal}
              setDisplayModal={() =>
                setModal({
                  playerModals: { showModal: false, modalType: 25, data: {} },
                })
              }
              modalType={playerModals.modalType}
              CloseModalAction={() =>
                setModal({
                  playerModals: { showModal: false, modalType: 25, data: {} },
                })
              }
              overlayZIndex={501}
              data={playerModals.data}
              background={
                ![26, 28, 29, 44].includes(playerModals.modalType) &&
                "linear-gradient(-203deg, #E08185 0,#9F93CF 74%, #8989D5 100%)"
              }
            />
          )}
          {playerModals2.showModal && (
            <SlideUp
              className={
                [26, 28, 29, 30].includes(playerModals2.modalType) &&
                "globalBackground"
              }
              displayModal={playerModals2.showModal}
              setDisplayModal={() =>
                setModal({
                  playerModals2: { showModal: false, modalType: 25, data: {} },
                })
              }
              modalType={playerModals2.modalType}
              CloseModalAction={() =>
                setModal({
                  playerModals2: { showModal: false, modalType: 25, data: {} },
                })
              }
              overlayZIndex={502}
              data={playerModals2.data}
              background={
                ![26, 28, 29, 30, 44].includes(playerModals2.modalType) &&
                "linear-gradient(-203deg, #E08185 0,#9F93CF 74%, #8989D5 100%)"
              }
            />
          )}
          {globalModals.showModal && (
            <SlideUp
              displayModal={globalModals.showModal}
              setDisplayModal={() =>
                setModal({
                  globalModals: { showModal: false, modalType: 29, data: {} },
                })
              }
              modalType={globalModals.modalType}
              CloseModalAction={() =>
                setModal({
                  globalModals: { showModal: false, modalType: 29, data: {} },
                })
              }
              overlayZIndex={602}
              data={globalModals.data}
            />
          )}
          {globalModals2.showModal && (
            <SlideUp
              displayModal={globalModals2.showModal}
              setDisplayModal={() =>
                setModal({
                  globalModals2: { showModal: false, modalType: 29, data: {} },
                })
              }
              modalType={globalModals2.modalType}
              CloseModalAction={() =>
                setModal({
                  globalModals2: { showModal: false, modalType: 29, data: {} },
                })
              }
              overlayZIndex={603}
              data={globalModals2.data}
            />
          )}
          {EOYRecap.showModal && (
            <SlideUp
              className={
                [26, 28, 29].includes(EOYRecap.modalType) && "globalBackground"
              }
              displayModal={EOYRecap.showModal}
              setDisplayModal={() =>
                setModal({
                  EOYRecap: { showModal: false, modalType: 25, data: {} },
                })
              }
              modalType={EOYRecap.modalType}
              CloseModalAction={() =>
                setModal({
                  EOYRecap: { showModal: false, modalType: 25, data: {} },
                })
              }
              overlayZIndex={1001}
              data={EOYRecap.data}
              background={
                ![26, 28, 29, 44].includes(EOYRecap.modalType) &&
                "linear-gradient(-203deg, #E08185 0,#9F93CF 74%, #8989D5 100%)"
              }
            />
          )}
        </>
      )}
      {/* Additional ID is Jason Warren */}
      {[
        ...allAccessUsers,
        // "VDGhhTvaB88dKM7kU2eY"
      ].includes(userid) &&
        !isDifferentUser && (
          <FlexRow
            align="center"
            justify="center"
            style={{ marginBottom: 10, paddingTop: isDifferentUser && 20 }}
          >
            <LargeButton
              gradient
              style={{
                width: "80%",
                boxShadow: `0 2px 5px #9f93cf`,
                padding: "15px 10px",
                border: "1px solid #00d8ff70",
              }}
              className="upgrade-bg"
              onClick={() => {
                // console.log(
                //   "EOY userid: ",
                //   isDifferentUser ? externalData._source.userID : null
                // );
                // if (isDifferentUser) {
                setModal({
                  EOYRecap: {
                    showModal: true,
                    modalType: 25,
                    data: {
                      avatarLink: data.avatarLink,
                      displayName: data.displayName,
                    },
                  },
                });
                // } else {
                //   setModal({
                //     EOYRecap: {
                //       showModal: true,
                //       modalType: 25,
                //       data: {
                //         avatarLink: data.avatarLink,
                //         displayName: data.displayName,
                //       },
                //     },
                //   });
                // }
              }}
            >
              <ButtonText>2025 Year End Recap</ButtonText>
            </LargeButton>
          </FlexRow>
        )}
      {isDifferentUser && (
        <FlexRow align="center" justify="center" style={{ marginBottom: 10 }}>
          <LargeButton
            style={{
              width: "60%",
              padding: "10px 10px",
            }}
            onClick={() => LaunchCompare()}
          >
            <ButtonText>Compare Stats</ButtonText>
            <AiOutlineLineChart
              size={26}
              color={"#fff"}
              style={{ marginLeft: 5 }}
            />
          </LargeButton>
        </FlexRow>
      )}
      <ContentSection
        style={{
          flex: 0,
          margin: "0 20px",
          padding: viewType === 2 ? 0 : "10px 0 0",
        }}
      >
        {!isDifferentUser ? (
          <BiEdit
            size={30}
            color={Global.red}
            style={{
              position: "absolute",
              padding: 2,
              right: 15,
              top: 15,
              zIndex: 5,
              borderRadius: 20,
            }}
            onClick={() => ShowModalType(3)}
          />
        ) : isDifferentUser && player.accountID === data.clubAccount ? (
          <LargeButton
            style={{ margin: "10px auto" }}
            onClick={() => ShowModalType(5)}
          >
            <ButtonText style={{ fontSize: 12, fontWeight: "800" }}>
              Remove from Club
            </ButtonText>
            <MdPersonRemove size={18} color="#fff" style={{ marginLeft: 10 }} />
          </LargeButton>
        ) : null}
        <div
          style={{
            height: 350,
            display: "flex",
            flex: 1,
            alignContent: "center",
            justifyContent: "center",
            paddingTop: 15,
          }}
        >
          {viewType > 0 && data.avatarLink !== "" ? (
            <img
              src={data.avatarLink}
              alt="profile"
              style={{
                // width: "100%",
                height: 250,
                objectFit: "contain",
                objectPosition: "top",
                borderRadius: 20,
                boxShadow: "0px 4px 8px #9a9a9a70",
              }}
            />
          ) : (
            <FaUserCircle
              className="mainFontColor"
              size={180}
              style={{ alignSelf: "flex-start" }}
            />
          )}
        </div>
        <div
          style={{
            position: "relative",
          }}
        >
          {!isDifferentUser && (
            <LargeButton
              style={{ margin: "10px auto" }}
              onClick={() => ShowModalType(0)}
            >
              <ButtonText style={{ fontSize: 24 }}>Scan In</ButtonText>
              <FaQrcode size={25} color="#fff" style={{ marginLeft: 10 }} />
            </LargeButton>
          )}
          <FlexColumn align="center" justify="center">
            <ContentSection>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                }}
              >
                <FlexColumn justify={"center"} align={"center"}>
                  <Text size="24px" style={{ fontWeight: "600" }}>
                    {`${data.displayName}`}
                  </Text>
                  <FlexRow>
                    <Text size="14px" style={{ textAlign: "center" }}>
                      {`${data.firstName} ${data.lastName} - ${
                        data.clubName === 0 ? "No Club" : data.clubName
                      }`}
                    </Text>
                  </FlexRow>
                </FlexColumn>
                <FlexRow align="flex-end" justify="space-around">
                  {player.sport !== "pickleball" && (
                    <StatBlock topText={data.currentRanking} bottomText="SPR" />
                  )}
                  <StatBlock
                    topText={
                      data.totalWins > 0
                        ? `${parseFloat(
                            ((data.totalWins + 0.5 * data.totalTies) /
                              data.totalMatches) *
                              100
                          ).toFixed(0)}%`
                        : "0"
                    }
                    bottomText="Win %"
                  />
                  {viewType === 2 && (
                    <>
                      {player.profileData.hasPpr && (
                        <>
                          <StatBlock topText={data.ppr} bottomText="PPR" />
                          <StatBlock topText={data.dpr} bottomText="DPR" />
                        </>
                      )}
                      <StatBlock
                        topTextSize={data.streak > 9 && "15px"}
                        topText={
                          data.streak > 0
                            ? `+${data.streak}${data.streak > 4 ? "🔥" : ""}`
                            : `${data.streak}${data.streak < -4 ? "🧊" : ""}`
                        }
                        bottomText="Streak"
                        color={
                          data.streak === 0
                            ? "mainFontColor"
                            : data.streak > 0
                            ? "green"
                            : "red"
                        }
                      />
                    </>
                  )}
                </FlexRow>
              </div>
            </ContentSection>
          </FlexColumn>
        </div>
      </ContentSection>
      <FlexRowFluid
        direction={"column"}
        style={{
          flex: 0,
          alignSelf: "stretch",
          margin: "15px",
        }}
      >
        <ContentSection
          className={"animate__animated animate__bounceInLeft"}
          // onClick={() => setShowAdvancedStats(!showAdvancedStats)}
          style={{
            margin: "5px 5px 15px",
            // alignSelf: "flex-start"
          }}
        >
          <FlexRow justify="center" align="center">
            <Text size="12px" style={{ textAlign: "center" }}>
              Rankings
            </Text>
          </FlexRow>
          <FlexRowFluid align="center">
            <StatBlock
              topText={
                <FlexRow align="center">
                  <Text size="10px">#</Text>
                  <Text size="20px" style={{ fontWeight: "700" }}>
                    {data.clubRank.toLocaleString()}
                  </Text>
                  {data.clubRankChange === 0 ? null : (
                    <Text
                      size="13px"
                      color={data.clubRankChange > 0 ? "green" : "red"}
                      style={{ marginLeft: 3 }}
                    >
                      {data.clubRankChange > 0
                        ? `+${data.clubRankChange}`
                        : `${data.clubRankChange}`}
                    </Text>
                  )}
                </FlexRow>
              }
              bottomText="Club"
            />
            {data &&
              ((data.country === "US" &&
                stateList.find((s) => s.value === data.state)) ||
                (data.country === "CA" &&
                  provinceList.find((s) => s.value === data.state))) &&
              data.state !== "" && (
                <StatBlock
                  topText={
                    <FlexRow align="center">
                      <Text size="10px">#</Text>
                      <Text size="20px" style={{ fontWeight: "700" }}>
                        {data.stateRank.toLocaleString()}
                      </Text>
                      {data.stateRankChange === 0 ? null : (
                        <Text
                          size="13px"
                          color={data.stateRankChange > 0 ? "green" : "red"}
                          style={{ marginLeft: 3 }}
                        >
                          {data.stateRankChange > 0
                            ? `+${data.stateRankChange}`
                            : `${data.stateRankChange}`}
                        </Text>
                      )}
                    </FlexRow>
                  }
                  bottomText={
                    data.country === "US"
                      ? stateList.find((s) => s.value === data.state).name
                      : data.country === "CA"
                      ? provinceList.find((s) => s.value === data.state).name
                      : ""
                  }
                />
              )}
            <StatBlock
              topText={
                <FlexRow align="center">
                  {!data.hiddenGlobalRank && <Text size="10px">#</Text>}
                  <Text size="20px" style={{ fontWeight: "700" }}>
                    {data.hiddenGlobalRank
                      ? "Hidden"
                      : data.globalRank.toLocaleString()}
                  </Text>
                  {data.globalRankChange === 0 ? null : (
                    <Text
                      size="13px"
                      color={data.globalRankChange > 0 ? "green" : "red"}
                      style={{ marginLeft: 3 }}
                    >
                      {data.globalRankChange > 0
                        ? `+${data.globalRankChange}`
                        : `${data.globalRankChange}`}
                    </Text>
                  )}
                </FlexRow>
              }
              bottomText="Global"
            />
          </FlexRowFluid>
          <FlexRow
            justify="space-around"
            align="center"
            style={{ marginTop: 15, width: "100%", gap: "10px" }}
          >
            <button
              onClick={() =>
                setModal({
                  globalModals: {
                    showModal: true,
                    modalType: 44,
                    data: {
                      userid: isDifferentUser
                        ? externalData._source.userID
                        : player.userID,
                      isDifferentUser,
                      blur: viewType < 2,
                      profileData: data,
                    },
                  },
                })
              }
              className="trophyRoomBtn"
            >
              <GiLaurelsTrophy size={18} color="#000" className="trophyIcon" />
              <Text
                size=".9em"
                style={{ fontWeight: "700", marginLeft: 5 }}
                color="black"
              >
                Trophy Room
              </Text>
            </button>
            {allAccessUsers.includes(userid) && !isDifferentUser && (
              <LargeButton
                style={{ padding: "5px 1em" }}
                onClick={() =>
                  setModal({
                    globalModals: {
                      showModal: true,
                      modalType: 62,
                      data: { isCompare: true },
                    },
                  })
                }
              >
                <FaPeopleArrows
                  size={15}
                  color="#fff"
                  style={{ marginRight: 5 }}
                />
                <ButtonText style={{ fontSize: ".9em" }}>Compare</ButtonText>
              </LargeButton>
            )}
          </FlexRow>
        </ContentSection>
        {player.sport === "billiards" || player.sport === "pickleball" ? (
          <ContentSection
            className={"animate__animated animate__bounceInLeft"}
            style={{
              margin: "5px 5px 15px",
            }}
          >
            <FlexRow justify="center" align="center">
              {player.sport === "pickleball" ? (
                <img
                  src={require(`../../assets/${
                    darkMode ? "dupr_light.png" : "dupr.jpg"
                  }`)}
                  alt="profile"
                  style={{
                    height: 20,
                    objectFit: "contain",
                  }}
                />
              ) : (
                <Text size="12px" style={{ textAlign: "center" }}>
                  {player.sport === "billiards" ? "FargoRate" : "DUPR"}
                </Text>
              )}
            </FlexRow>
            {(player.sport === "billiards" && data.fargoRateExists) ||
            (player.sport === "pickleball" &&
              data.duprId &&
              data.duprId !== "") ||
            isDifferentUser ? (
              <>
                <FlexRowFluid align="center">
                  <StatBlock
                    topText={
                      player.sport === "billiards"
                        ? data.fargoRateCurrent.toLocaleString()
                        : data.duprSingles === 0
                        ? "NR"
                        : data.duprSingles.toLocaleString()
                    }
                    bottomText={
                      player.sport === "billiards" ? "FargoRate" : "Singles"
                    }
                  />
                  <StatBlock
                    topText={
                      player.sport === "billiards"
                        ? data.fargoRobustness.toLocaleString()
                        : data.duprDoubles === 0
                        ? "NR"
                        : data.duprDoubles.toLocaleString()
                    }
                    bottomText={
                      player.sport === "billiards" ? "Robustness" : "Doubles"
                    }
                  />
                </FlexRowFluid>
                {player.sport === "pickleball" && data.duprLastUpdated && (
                  <FlexRow
                    style={{ width: "100%", marginTop: 15 }}
                    align="center"
                    justify="center"
                  >
                    <Text size=".6em" style={{ fontStyle: "italic" }}>
                      Last updated{" "}
                      {moment(data.duprLastUpdated, "X").format(
                        "MM/DD/YY h:mma z"
                      )}
                    </Text>
                  </FlexRow>
                )}
                {!isDifferentUser && (
                  <FlexRow
                    align="center"
                    justify="center"
                    style={{ width: "100%", marginTop: 10 }}
                  >
                    <LargeButton
                      onClick={() =>
                        setModal({
                          globalModals: {
                            showModal: true,
                            modalType: 5,
                            data:
                              player.sport === "pickleball"
                                ? {
                                    userid: player.userID,
                                    type: "unlinkDupr",
                                    heading: "Unlink DUPR Account",
                                    buttonConfirmText: "Unlink",
                                    info: "Are you sure you want to unlink your DUPR account? You can relink it at any time.",
                                  }
                                : {
                                    userid: player.userID,
                                    type: "unlinkFargo",
                                    heading: "Unlink Fargo Account",
                                    buttonConfirmText: "Unlink",
                                    info: "Are you sure you want to unlink your Fargo account? You can relink it at any time.",
                                  },
                          },
                        })
                      }
                      style={{ padding: "5px 10px", width: "auto" }}
                    >
                      <ButtonText style={{ fontSize: ".7em" }}>
                        Unlink{" "}
                        {player.sport === "pickleball" ? "DUPR" : "Fargo"}{" "}
                        Account
                      </ButtonText>
                    </LargeButton>
                  </FlexRow>
                )}
              </>
            ) : (
              <LargeButton
                style={{ margin: "10px auto 0", padding: "10px 20px" }}
                onClick={() =>
                  player.sport === "billiards"
                    ? ShowModalType(4)
                    : OpenExternalURL(
                        `https://app.scoreholio.com/duprlogin?user=${player.userID}`,
                        platform
                      )
                }
              >
                <ButtonText style={{ fontSize: 12, fontWeight: "800" }}>
                  Link to{" "}
                  {player.sport === "billiards" ? "Fargo Account" : "DUPR"}
                </ButtonText>
              </LargeButton>
            )}
          </ContentSection>
        ) : null}

        <ContentSection
          className={"animate__animated animate__bounceInLeft"}
          // onClick={() => setShowAdvancedStats(!showAdvancedStats)}
          style={{
            margin: "5px",
          }}
        >
          <UpgradeBlurComponent
            isVisible={viewType < 2}
            hideBlurBG={true}
            blurStyle={{ top: 40, bottom: 50 }}
            children={
              <>
                <FlexRow justify="center" align="center">
                  <Text size="12px" style={{ textAlign: "center" }}>
                    General Stats
                  </Text>
                </FlexRow>
                <FlexRow
                  justify="flex-end"
                  align="center"
                  style={{ flexWrap: "wrap" }}
                >
                  <StatBlock
                    topText={data.totalWins.toLocaleString()}
                    bottomText="Win"
                    blur={viewType < 2}
                  />
                  <StatBlock
                    topText={data.totalLosses.toLocaleString()}
                    bottomText="Loss"
                    blur={viewType < 2}
                  />
                  <StatBlock
                    topText={data.totalTies}
                    bottomText="Tie"
                    blur={viewType < 2}
                  />
                </FlexRow>
                <FlexRow justify="flex-start" align="flex-start">
                  <StatBlock
                    topText={data.totalPointsFor.toLocaleString()}
                    bottomText="Points For"
                    blur={viewType < 2}
                  />
                  <StatBlock
                    topText={data.totalPointsAgainst.toLocaleString()}
                    bottomText="Points Against"
                    blur={viewType < 2}
                  />
                </FlexRow>
                {player.profileData.hasPpr && (
                  <>
                    <FlexRow
                      style={{
                        marginTop: 20,
                      }}
                      justify="center"
                      align="center"
                    >
                      <Text size="12px" style={{ textAlign: "center" }}>
                        Scoremagic Stats
                      </Text>
                    </FlexRow>
                    <FlexColumn
                      align="stretch"
                      style={{ flex: 1, width: "100%" }}
                    >
                      <SwipeTabs
                        action={tabsRef}
                        value={value}
                        onChange={handleChange}
                        // indicatorColor="secondary"
                        textColor="inherit"
                        // variant="fullWidth"
                        aria-label="scoremagic tabs"
                        marginTop="0"
                        variant="scrollable"
                        scrollButtons="auto"
                        // scrollButtons="auto"
                        width={"33%"}
                      >
                        <SwipeTab
                          label="30 Days"
                          {...a11yProps(0)}
                          style={{
                            width: "33.33333%",
                          }}
                        />
                        <SwipeTab
                          label="120 Days"
                          {...a11yProps(1)}
                          style={{
                            width: "33.33333%",
                          }}
                        />
                        <SwipeTab
                          label="All Time"
                          {...a11yProps(2)}
                          style={{
                            width: "33.33333%",
                          }}
                        />
                      </SwipeTabs>

                      <StyledToggleButtonGroup
                        size="small"
                        {...formatTypeControl}
                        aria-label="format-type-btns"
                        className="format-type-btns"
                      >
                        {formatTypeButtons}
                      </StyledToggleButtonGroup>
                      <SwipeableViews
                        axis={"x"}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                      >
                        <ScoremagicStatsWrapper
                          sport={sport}
                          viewType={viewType}
                          data={pprSummary30}
                          formatType={formatType}
                          value={value}
                        />
                        <ScoremagicStatsWrapper
                          sport={sport}
                          viewType={viewType}
                          data={pprSummary120 ? pprSummary120 : data}
                          formatType={formatType}
                          value={value}
                        />

                        <ScoremagicStatsWrapper
                          sport={sport}
                          viewType={viewType}
                          data={pprSummaryAll}
                          formatType={formatType}
                          value={value}
                        />
                      </SwipeableViews>
                    </FlexColumn>
                    {/* {!isDifferentUser && ( */}
                    {sport === "cornhole" && (
                      <FlexRow
                        align="center"
                        justify="center"
                        style={{ marginTop: 15 }}
                      >
                        <LargeButton
                          style={{ padding: "5px 12px 5px 15px" }}
                          onClick={() =>
                            setModal({
                              playerModals2: {
                                showModal: true,
                                modalType: 28,
                                data: {
                                  userid: isDifferentUser
                                    ? externalData._source.userID
                                    : player.userID,
                                  isDifferentUser,
                                },
                              },
                            })
                          }
                        >
                          <AiOutlineLineChart
                            style={{ marginRight: 10 }}
                            color={"#fff"}
                            size={20}
                          />
                          <ButtonText style={{ fontSize: 12 }}>
                            {isDifferentUser ? "Bag" : "Bag/Tag"} Breakdown
                          </ButtonText>
                        </LargeButton>
                      </FlexRow>
                    )}
                    {/* )} */}
                  </>
                )}
              </>
            }
          />
        </ContentSection>
      </FlexRowFluid>
      <ContentSection
        style={{
          flex: 0,
          margin: "0 20px 20px",
          padding: "20px 0",
        }}
        className="animate__animated animate__bounceInLeft bagStats"
      >
        <UpgradeBlurComponent
          isVisible={viewType < 2}
          // hideBlurBG={true}
          blurStyle={{ top: 30, left: 0, right: 0, bottom: 0 }}
          children={
            <>
              <FlexRow justify="center">
                <Text size="12px" style={{ textAlign: "center" }}>
                  Play History
                </Text>
              </FlexRow>
              <FlexColumn align="stretch" style={{ flex: 1, width: "100%" }}>
                <SwipeTabs
                  value={playHistoryValue}
                  onChange={handlePlayHistoryValueChange}
                  // indicatorColor="secondary"
                  textColor="inherit"
                  // variant="fullWidth"
                  aria-label="play history tabs"
                  marginTop="0"
                  variant="scrollable"
                  scrollButtons="auto"
                  // scrollButtons="auto"
                  width={"50%"}
                  TabIndicatorProps={{
                    style: { transition: "none" },
                  }}
                >
                  <SwipeTab
                    label="All"
                    {...a11yProps(0)}
                    style={{
                      width: "50%",
                    }}
                  />
                  <SwipeTab
                    label="Grouped"
                    {...a11yProps(1)}
                    style={{
                      width: "50%",
                    }}
                  />
                </SwipeTabs>
                <SwipeableViews
                  axis={"x"}
                  index={playHistoryValue}
                  onChangeIndex={handlePlayHistoryChangeIndex}
                >
                  {playHistoryValue === 0 && (
                    <div className="play-history-div">
                      <GridTable
                        dataCallBody={{
                          sport: sport,
                          userid: isDifferentUser
                            ? externalData._source.userID
                            : player.userID,
                        }}
                        getRowId={(params) => params.data.historyId}
                        apiURL="player/v2/match-history"
                        dataCall={() => getMatchHistory()}
                        error={matchHistoryError}
                        columnDefs={playerHistoryColDefs}
                        modalData={modalData}
                        setModalData={setModalData}
                        ShowModalType={(d) => ShowModalType(2, d)}
                        shouldShowModal={true}
                        showSearchBar={true}
                        rowClassRules={rowClassRulesProfileMatch}
                      />
                    </div>
                  )}

                  {playHistoryValue === 1 && (
                    <div className="play-history-div">
                      <GridTableClient
                        type="match-history"
                        dataCallBody={{
                          sport: sport,
                          userid: isDifferentUser
                            ? externalData._source.userID
                            : player.userID,
                        }}
                        apiURL="player/v2/match-history-group"
                        dataCall={() => getMatchHistory()}
                        error={matchHistoryError}
                        columnDefs={playerHistoryGroupColDefs}
                        shouldShowModal={false}
                        showSearchBar={true}
                        rowClassRules={rowClassRulesProfileMatch}
                        masterDetailEnabled={true}
                        masterDetailOptions={detailCellRendererParams}
                        modalData={modalData}
                        setModalData={setModalData}
                        ShowModalType={() => ShowModalType(2)}
                        setModal={setModal}
                        hideFilter
                      />
                    </div>
                  )}
                </SwipeableViews>
              </FlexColumn>
            </>
          }
        />
      </ContentSection>
      <>
        <SwipeCharts
          blur={viewType < 2}
          data={data}
          userID={isDifferentUser ? externalData._source.userID : userid}
          sport={sport}
          type="mainProfile"
        />
        {viewType === 2 && sport !== "pickleball" && (
          <ContentSection
            style={{
              flex: 0,
              margin: "0 20px 50px",
            }}
            className={"animate__animated animate__bounceInLeft"}
          >
            <Text size="12px" style={{ textAlign: "center" }}>
              SPR Corrections
            </Text>
            <FlexRow>
              <StatBlock
                topText={data.CprDeleted} //Need to make sure we have this
                bottomText="Processed"
                direction={viewType < 2 && "column-reverse"}
                blur={viewType < 2}
              />
              <StatBlock
                topText={data.CprPending}
                bottomText="Pending"
                direction={viewType < 2 && "column-reverse"}
                blur={viewType < 2}
              />
              <StatBlock
                topText={data.CprDenied}
                bottomText="Denied"
                direction={viewType < 2 && "column-reverse"}
                blur={viewType < 2}
              />
              <StatBlock
                topText={`${parseFloat(data.CprPercentage).toFixed(1)}%`}
                bottomText="CPR"
                direction={viewType < 2 && "column-reverse"}
                blur={viewType < 2}
              />
            </FlexRow>
          </ContentSection>
        )}
      </>
      {data.lastUpdated && data.lastUpdated !== "" && (
        <FlexRow
          style={{ width: "100%", marginBottom: 5, marginTop: 10 }}
          align="center"
          justify="center"
        >
          <Text
            size=".7em"
            style={{ textAlign: "center" }}
          >{`Profile last updated: ${moment(data.lastUpdated, "X").format(
            "h:mma M/D/YYYY"
          )}`}</Text>
        </FlexRow>
      )}
      {!isDifferentUser && player.pin && (
        <FloatingButton>
          <AiFillSetting
            onClick={() => ShowModalType(1)}
            size={25}
            color="#fff"
            style={{ marginLeft: -1 }}
          />
        </FloatingButton>
      )}
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        flex: 1,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack spacing={2} style={{ marginTop: 10, width: "92%" }}>
        <Skeleton
          variant="rectangular"
          height={300}
          style={{ borderRadius: 20 }}
        />
        <Skeleton
          variant="rectangular"
          height={200}
          style={{ borderRadius: 20 }}
        />
        <Skeleton
          variant="rectangular"
          height={200}
          style={{ borderRadius: 20 }}
        />
        <Skeleton
          variant="rectangular"
          height={200}
          style={{ borderRadius: 20 }}
        />
      </Stack>
    </div>
  );
};

export default connect(null, mapDispatch)(MainProfile);
